import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@ublend-npm/aulaui-next-web/Avatar';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

import {
  ListItem,
  ListItemText,
  ListItemAvatar,
} from './HistoryListItem.styled';
import { isAddOrUpdate } from './historyEventsHelpers';

const HistoryListItem = ({
  size,
  avatar,
  participant,
  user,
  isEducator,
  eventType,
}) => (
  <ListItem alignItems="flex-start" size={size}>
    <ListItemAvatar>
      <Avatar size={size} name={participant} src={avatar} />
    </ListItemAvatar>
    <ListItemText
      isAddAction={isAddOrUpdate(eventType)}
      primary={
        <span>
          {participant}{' '}
          {isEducator && (
            <span style={{ color: colors.designSystem.marker }}>
              (Educator){' '}
            </span>
          )}
          {size !== 'small' ? `was ${eventType} by ${user}` : ''}
        </span>
      }
    />
  </ListItem>
);

HistoryListItem.propTypes = {
  size: PropTypes.string,
  avatar: PropTypes.string,
  participant: PropTypes.string.isRequired,
  user: PropTypes.string.isRequired,
  isEducator: PropTypes.bool,
  eventType: PropTypes.string.isRequired,
};

HistoryListItem.defaultProps = {
  size: 'large',
  avatar: null,
  isEducator: false,
};

export default HistoryListItem;
